var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcAdministrativeExpenses = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "34px",
  height: "34px",
  viewBox: "0 0 34 34",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref,
  "aria-labelledby": titleId
}, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, "ic_administrative_expenses_02") : title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Artboard",
  transform: "translate(-157.000000, -155.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "ic_administrative_expenses_02",
  transform: "translate(157.000000, 155.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_320",
  x: 0,
  y: 0,
  width: 34,
  height: 34
}), /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_351",
  transform: "translate(2.000000, 7.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 0,
  y: 0,
  width: 30,
  height: 20,
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  stroke: "#FFFFFF",
  x: 0.5,
  y: 0.5,
  width: 29,
  height: 19,
  rx: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_983",
  transform: "translate(4.160000, 10.385000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Path_291",
  transform: "translate(0.113000, 6.432000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0.726,6.054 L10.726,6.054 C10.726,6.054 10.726,3.571 10.726,3.23 C10.726,2.908 9.952,0.939 6.454,0.692 C5.86788178,0.631668589 5.27711822,0.631668589 4.691,0.692 C1.777,0.928 0.726,2.981 0.726,3.334 C0.727,3.712 0.726,6.054 0.726,6.054 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.72558594,5.05407715 C9.72509766,4.40917969 9.72485352,3.63549805 9.72583008,3.32165527 C9.63476562,3.09851074 9.01464844,1.87524414 6.38330078,1.68920898 L6.24462891,1.67932129 C5.92944336,1.65686035 5.78564453,1.64660645 5.65551758,1.64660645 C5.54003906,1.64660645 5.39770508,1.65454102 5.13891602,1.66882324 C5.03271484,1.67468262 4.90820312,1.68164062 4.75805664,1.68945312 C2.75878906,1.85668945 1.8894043,3.05847168 1.7265625,3.44494629 C1.72680664,3.75805664 1.72680664,4.45751953 1.7265625,5.05407715 L9.72558594,5.05407715 M10.7263182,6.05407715 L0.726318189,6.05407715 C0.726318189,6.05407715 0.727294922,3.71179199 0.726318189,3.33410645 C0.725830078,2.98059082 1.77734375,0.927856445 4.69091797,0.691650391 C5.76489258,0.635375977 5.55224609,0.627807617 6.45385742,0.691650391 C9.95214844,0.938964844 10.7294922,2.90820312 10.7263182,3.2298584 C10.7236328,3.57141113 10.7263182,6.05407715 10.7263182,6.05407715 Z",
  id: "Shape",
  fill: "#FFFFFF",
  fillRule: "nonzero"
})), /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_59",
  transform: "translate(2.839000, 0.743000)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  stroke: "#FFFFFF",
  cx: 3,
  cy: 3,
  r: 2.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "iconfinder_money_172506-copy",
  transform: "translate(19.000000, 14.000000)",
  stroke: "#FFFFFF",
  strokeLinecap: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4.08452046,0.169619688 C6.50360735,0.169619688 8,0.841357078 8,1.66921937 C8,2.49708166 6.50296974,3.16961969 4.08452046,3.16961969 C1.66607118,3.16961969 0,2.4978823 0,1.66921937 C0,0.840556437 1.66543357,0.169619688 4.08452046,0.169619688 Z",
  id: "Path_304"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0,1.60785835 L0,4.46679115 C0,5.31357005 1.79049436,6 4,6 C6.20950564,6 8,5.31357005 8,4.46679115 L8,1.71644648",
  id: "Path_301",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0,4.58328585 L0,7.5248646 C0,8.33957 1.79049436,9 4,9 C6.20950564,9 8,8.33957 8,7.5248646 L8,4.62694488",
  id: "Path_302",
  strokeLinejoin: "round"
})))))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcAdministrativeExpenses);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "matrices-static/media/ic_administrative_expenses.e9ed76ca86f053719777d6b7f902a4b6.svg";